import { Component } from '@angular/core';
import { AccessService } from '@app-core/services/access/access.service';

@Component({
  selector: 'app-eula-document',
  templateUrl: './eula-document.component.html',
  styleUrls: ['./eula-document.component.scss'],
})
export class EulaDocumentComponent {
  constructor(private accessService: AccessService) {}

  public loginInfo = this.accessService.getLoginInfo();

  public get showSatrackTemplate(): boolean {
    return [
      'satrack',
      'satrackstaging', // for testing
    ].includes(this.loginInfo?.customerName);
  }
}
